module.exports = __webpack_public_path__ + "img/head-paso4.41887b06.svg";